import React from "react";
import { Empty, Scrollbar, theme } from "codeArt/components/Base";
import Portal from "codeArt/components/Portal";
import { AreaChart, ChartYHanle, ManyAxisAreaChart } from "./common";
import { threePosition, runtime } from "codeArt/common";
import ReactEcharts from "echarts-for-react";
import { DashedPanel } from "codeArt/components/accessory";

export class OutputChart extends React.Component {
  constructor(props) {
    super(props);
  }

  getOption() {
    let { data, xData, grid, lineColor, ymin, ymax } = this.props;
    let option = {};
    let my = this;

    option.tooltip = {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: function (params) {
        let tip = "";
        let name = "";
        params.forEach(t => {
          name = t.name;
          let value =
            t.seriesType == "line"
              ? `${(t.value * 100).toFixed(1)} %`
              : `${t.value}万`;
          let item = `${t.marker}${t.seriesName} : ${value} </br>`;
          tip = item + tip;
        });

        return `${name}</br>${tip}`;
      }
    };

    option.legend = { data: ["总产量", "合格的产量", "出棒率"] };

    option.grid = {
      left: "10",
      right: "10",
      bottom: "10",
      top: "40",
      containLabel: true
    };
    option.grid = Object.assign(option.grid, grid);

     xData = xData || ["1月", "2月", "3月", "4月", "5月", "6月", "7月"];
    let xAxis = [
      {
        type: "category",
        axisLine: { show: true },
        axisTick: { alignWithLabel: true },
        axisLabel: { show: true },
        splitArea: { show: false },
        splitLine: { show: false },
        data: xData
      },
      {
        type: "category",
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
        splitArea: { show: false },
        splitLine: { show: false },
        data: xData
      },
      {
        type: "category",
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
        splitArea: { show: false },
        splitLine: { show: false },
        data: xData
      }
    ];

    let yAxis = [
      {
        type: "value",
        name: "",
        min: ymin,
        max: ymax,
        interval: 20,
        axisLine: { show: true },
        splitLine: { show: false },
        axisLabel: {
          formatter: v => {
            return v + "万";
          }
        }
      },
      {
        type: "value",
        name: "",
        axisLine: { show: true },
        min: 0.9,
        max: 1,
        interval: 0.02,
        splitLine: {
          show: true,
          lineStyle: { type: "dashed", color: lineColor }
        },
        axisLabel: {
          formatter: v => {
            return v * 100 + "%";
          }
        }
      }
    ];

    option.xAxis = xAxis;
    option.yAxis = yAxis;

    option.series = [
      {
        name: "总产量",
        type: "bar",
        barGap: "0",
        barWidth: "70%",
        xAxisIndex: 1,
        itemStyle: { normal: { color: theme.color.blue } },
        label: {
          show: true,
          position: "top",
          backgroundColor: "transparent",
          formatter: v => {
            return v.value + "万";
          }
        },
        data: data[0]
      },
      {
        name: "合格的产量",
        type: "bar",
        barGap: "0",
        barWidth: "55%",
        xAxisIndex: 2,
        itemStyle: { normal: { color: theme.color.teal } },
        label: {
          show: true,
          position: "inside",
          backgroundColor: "transparent",
          formatter: v => {
            return v.value + "万";
          }
        },
        data: data[1]
      },
      {
        name: "出棒率",
        type: "line",
        symbol: "circle",
        symbolSize: 5,
        sampling: "average",
        yAxisIndex: 1,
        color: theme.color.yellow,
        label: {
          show: true,
          position: "top",
          backgroundColor: "transparent",
          formatter: v => {
            return `${(v.value * 100).toFixed(1)} %`;
          }
        },
        data: data[2]
      }
    ];

    return option;
  }

  getEvents() {
    let { onClick } = this.props;
    if (!onClick) return {};
    return { click: onClick };
  }

  render() {
    return (
      <ReactEcharts
        option={this.getOption()}
        notMerge={true}
        lazyUpdate={true}
        className={"w-100 h-100"}
        onEvents={this.getEvents()}
      />
    );
  }
}

OutputChart.defaultProps = {
  lineColor: "#f0f0f0",
  ymin: 200,
  ymax: 300
};

export class QualifiedRankTrendChart extends React.Component {
  constructor(props) {
    super(props);
  }

  getOption() {
    let { data, grid, lineColor, ymin, ymax } = this.props;
    let option = {};
    let my = this;

    option.tooltip = {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: function (params) {
        let tip = "";
        let name = "";
        params.forEach(t => {
          name = t.name;
          t.value = threePosition(t.value);
          let value =
            t.seriesType == "line"
              ? `${(t.value * 100).toFixed(1)} %`
              : `${t.value}万`;
          let item = `${t.marker}${t.seriesName} : ${value} </br>`;
          tip = item + tip;
        });

        return `${name}</br>${tip}`;
      }
    };

    // option.legend = { data: ["总产量", "合格的产量", "出棒率"] };

    option.grid = {
      left: "10",
      right: "10",
      bottom: "10",
      top: "40",
      containLabel: true
    };
    option.grid = Object.assign(option.grid, grid);

    let xData = ["三月", "四月", "五月", "六月", "七月"];
    let xAxis = [
      {
        type: "category",
        axisLine: { show: true },
        axisTick: { alignWithLabel: true },
        axisLabel: { show: true },
        splitArea: { show: false },
        splitLine: { show: false },
        data: xData
      },
      {
        type: "category",
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
        splitArea: { show: false },
        splitLine: { show: false },
        data: xData
      },
      {
        type: "category",
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
        splitArea: { show: false },
        splitLine: { show: false },
        data: xData
      }
    ];

    let yAxis = [
      {
        type: "value",
        name: "",
        max: 1250000,
        min: 30000,
        interval: 122000,
        axisLine: { show: true },
        splitLine: { show: false },
        axisLabel: {
          format: v => {
            return (v / 10000).toFixed(2) + "万";
          }
        }
      }
      // {
      //   type: "value",
      //   name: "",
      //   axisLine: { show: true },
      //   min: 0.9,
      //   max: 1,
      //   interval: 0.02,
      //   splitLine: {
      //     show: true,
      //     lineStyle: { type: "dashed", color: lineColor }
      //   },
      //   axisLabel: {
      //     formatter: v => {
      //       return v * 100 + "%";
      //     }
      //   }
      // }
    ];

    option.xAxis = xAxis;
    option.yAxis = yAxis;

    option.series = [
      {
        name: "早班(总产量)",
        type: "bar",
        barGap: "10%",
        barWidth: "35%",
        xAxisIndex: 1,
        itemStyle: { normal: { color: theme.color["light-grey"] } },
        label: {
          show: true,
          position: "top",
          backgroundColor: "transparent",
          formatter: v => {
            let vw = (v.value / 10000).toFixed(2);
            return vw + "万";
          }
        },
        data: data[0]
      },
      {
        name: "早班(合格产量)",
        type: "bar",
        barGap: "55%",
        barWidth: "25%",
        xAxisIndex: 2,
        itemStyle: { normal: { color: "#ff3399" } },
        label: {
          show: true,
          position: "inside",
          backgroundColor: "transparent",
          formatter: v => {
            let vw = (v.value / 10000).toFixed(2);
            return vw + "万";
          }
        },
        data: data[1]
      },
      {
        name: "中班(总产量)",
        type: "bar",
        barGap: "10%",
        barWidth: "35%",
        xAxisIndex: 1,
        itemStyle: { normal: { color: theme.color["light-grey"] } },
        label: {
          show: true,
          position: "top",
          backgroundColor: "transparent",
          formatter: v => {
            let vw = (v.value / 10000).toFixed(2);
            return vw + "万";
          }
        },
        data: data[2]
      },
      {
        name: "中班(合格产量)",
        type: "bar",
        barGap: "55%",
        barWidth: "25%",
        xAxisIndex: 2,
        itemStyle: { normal: { color: theme.color.cyan } },
        label: {
          show: true,
          position: "inside",
          backgroundColor: "transparent",
          formatter: v => {
            let vw = (v.value / 10000).toFixed(2);
            return vw + "万";
          }
        },
        data: data[3]
      }
      // {
      //   name: "中班",
      //   type: "bar",
      //   barGap: "10",
      //   barWidth: "25%",
      //   xAxisIndex: 2,
      //   itemStyle: { normal: { color: theme.color.teal } },
      //   label: {
      //     show: true,
      //     position: "inside",
      //     backgroundColor: "transparent",
      //     formatter: v => {
      //       return v.value + "万";
      //     }
      //   },
      //   data: data[2]
      // }
      // {
      //   name: "晚班",
      //   type: "bar",
      //   barGap: "10",
      //   barWidth: "25%",
      //   xAxisIndex: 2,
      //   itemStyle: { normal: { color: theme.color.teal } },
      //   label: {
      //     show: true,
      //     position: "inside",
      //     backgroundColor: "transparent",
      //     formatter: v => {
      //       return v.value + "万";
      //     }
      //   },
      //   data: data[3]
      // }

      // {
      //   name: "出棒率",
      //   type: "line",
      //   symbol: "circle",
      //   symbolSize: 5,
      //   sampling: "average",
      //   yAxisIndex: 1,
      //   color: theme.color.yellow,
      //   label: {
      //     show: true,
      //     position: "top",
      //     backgroundColor: "transparent",
      //     formatter: v => {
      //       return `${(v.value * 100).toFixed(1)} %`;
      //     }
      //   },
      //   data: data[2]
      // }
    ];

    return option;
  }

  getEvents() {
    let { onClick } = this.props;
    if (!onClick) return {};
    return { click: onClick };
  }

  render() {
    return (
      <ReactEcharts
        option={this.getOption()}
        notMerge={true}
        lazyUpdate={true}
        className={"w-100 h-100"}
        onEvents={this.getEvents()}
      />
    );
  }
}

OutputChart.defaultProps = {
  lineColor: "#f0f0f0",
  ymin: 200,
  ymax: 300
};

export class QualifiedRankChart extends React.Component {
  constructor(props) {
    super(props);
  }

  getOption() {
    let { data, grid, lineColor, ymin, ymax, x } = this.props;
    let option = {};
    let my = this;

    option.tooltip = {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: function (params) {
        let tip = "";
        let name = "";
        params.forEach(t => {
          t.value = threePosition(t.value);
          name = t.name;
          let value =
            t.seriesType == "line"
              ? `${(t.value * 100).toFixed(1)} %`
              : `${t.value}`;
          let item = `${t.marker}${t.seriesName} : ${value} </br>`;
          tip = item + tip;
        });

        return `${name}</br>${tip}`;
      }
    };

    // option.legend = { data: ["总产量", "合格的产量", "出棒率"] };

    option.grid = {
      left: "10",
      right: "10",
      bottom: "10",
      top: "40",
      containLabel: true
    };
    option.grid = Object.assign(option.grid, grid);

    let xData = x.data;
    let xAxis = [
      {
        type: "category",
        axisLine: { show: true },
        axisTick: { alignWithLabel: true },
        axisLabel: { show: true },
        splitArea: { show: false },
        splitLine: { show: false },
        data: xData
      },
      {
        type: "category",
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
        splitArea: { show: false },
        splitLine: { show: false },
        data: xData
      },
      {
        type: "category",
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
        splitArea: { show: false },
        splitLine: { show: false },
        data: xData
      }
    ];

    let yAxis = [
      {
        type: "value",
        name: "",
        min: ymin,
        max: ymax,
        interval: 3.25,
        axisLine: { show: true },
        splitLine: { show: false },
        axisLabel: {
          formatter: v => {
            let vw = (v.value / 10000).toFixed(2);
            return vw + "万";
          }
        }
      }
      //   {
      //     type: "value",
      //     name: "",
      //     axisLine: { show: true },
      //     min: 0.9,
      //     max: 1,
      //     interval: 0.02,
      //     splitLine: {
      //       show: true,
      //       lineStyle: { type: "dashed", color: lineColor }
      //     },
      //     axisLabel: {
      //       formatter: v => {
      //         return v * 100 + "%";
      //       }
      //     }
      //   }
    ];

    option.xAxis = yAxis;
    option.yAxis = xAxis;

    // data[0] = data[0].map(item => {
    //   return threePosition(item);
    // });
    // data[1] = data[1].map(item => {
    //   return threePosition(item);
    // });

    option.series = [
      {
        name: "总产量",
        type: "bar",
        barGap: "0",
        barWidth: "70%",
        yAxisIndex: 1,
        itemStyle: { normal: { color: theme.color["light-grey"] } },
        label: {
          show: true,
          position: "right",
          backgroundColor: "transparent",
          formatter: v => {
            let vw = (v.value / 10000).toFixed(2);
            return vw + "万";
          }
        },

        data: data[0]
      },
      {
        name: "合格的产量",
        type: "bar",
        barGap: "0",
        barWidth: "55%",
        yAxisIndex: 2,
        itemStyle: {
          normal: {
            color: v => {
              switch (v.name) {
                case "四元复合棒":
                  v.color = theme.color.secondary;
                  break;
                case "三元复合棒":
                  v.color = theme.color.cyan;
                  break;
                case "二元复合棒":
                  v.color = theme.color.teal;
                  break;
                case "中空拉丝棒":
                  v.color = theme.color["r-orange"];
                  break;
                case "高透棒":
                  v.color = theme.color.purple;
                  break;
                case "爆珠棒":
                  v.color = theme.color["m-brand"];
                  break;
              }
              return v.color;
            }
          }
        },
        label: {
          show: true,
          position: "inside",
          backgroundColor: "transparent",
          formatter: v => {
            let vw = (v.value / 10000).toFixed(2);
            return vw + "万";
          }
        },
        data: data[1]
      }
      //   {
      //     name: "出棒率",
      //     type: "line",
      //     symbol: "circle",
      //     symbolSize: 5,
      //     sampling: "average",
      //     xAxisIndex: 1,
      //     color: theme.color.yellow,
      //     label: {
      //       show: true,
      //       position: "top",
      //       backgroundColor: "transparent",
      //       formatter: v => {
      //         return `${(v.value * 100).toFixed(1)} %`;
      //       }
      //     },
      //     data: data[2]
      //   }
    ];

    return option;
  }

  getEvents() {
    let { onClick } = this.props;
    if (!onClick) return {};
    return { click: onClick };
  }

  render() {
    return (
      <ReactEcharts
        option={this.getOption()}
        notMerge={true}
        lazyUpdate={true}
        className={"w-100 h-100"}
        onEvents={this.getEvents()}
      />
    );
  }
}

export class QualifiedRankShiftChart extends React.Component {
  constructor(props) {
    super(props);
  }

  getOption() {
    let { data, grid, lineColor, ymin, ymax, x, interval } = this.props;
    let option = {};
    let my = this;

    option.tooltip = {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: function (params) {
        let tip = "";
        let name = "";
        params.forEach(t => {
          t.value = threePosition(t.value);
          name = t.name;
          let value =
            t.seriesType == "line"
              ? `${(t.value * 100).toFixed(1)} %`
              : `${t.value}`;
          let item = `${t.marker}${t.seriesName} : ${value} </br>`;
          tip = item + tip;
        });

        return `${name}</br>${tip}`;
      }
    };

    // option.legend = { data: ["总产量", "合格的产量", "出棒率"] };

    option.grid = {
      left: "20",
      right: "50",
      bottom: "10",
      top: "40",
      containLabel: true
    };
    option.grid = Object.assign(option.grid, grid);

    let xData = x.data;
    let xAxis = [
      {
        type: "category",
        axisLine: { show: true },
        axisTick: { alignWithLabel: true },
        axisLabel: { show: true },
        splitArea: { show: false },
        splitLine: { show: false },
        data: xData
      },
      {
        type: "category",
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
        splitArea: { show: false },
        splitLine: { show: false },
        data: xData
      },
      {
        type: "category",
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
        splitArea: { show: false },
        splitLine: { show: false },
        data: xData
      }
    ];

    let yAxis = [
      {
        type: "value",
        name: "",
        min: ymin,
        max: ymax,
        interval: interval || 3.25,
        axisLine: { show: true },
        splitLine: { show: false },
        axisLabel: {
          show: true,
          formatter: v => {
            let vw = (v / 10000).toFixed(2);
            return vw + "万";
          }
        }
      }
    ];

    option.xAxis = yAxis;
    option.yAxis = xAxis;

    option.series = [
      {
        name: "总产量",
        type: "bar",
        barGap: "0",
        barWidth: "70%",
        yAxisIndex: 1,
        itemStyle: { normal: { color: theme.color["light-grey"] } },
        label: {
          show: true,
          position: "right",
          backgroundColor: "transparent",
          formatter: v => {
            let vw = (v.value / 10000).toFixed(2);
            return vw + "万";
          }
        },

        data: data[0]
      },
      {
        name: "合格的产量",
        type: "bar",
        barGap: "0",
        barWidth: "55%",
        yAxisIndex: 2,
        itemStyle: {
          normal: {
            color: v => {
              switch (v.name) {
                case "早班":
                  v.color = "#ff3399";
                  break;
                case "中班":
                  v.color = theme.color.cyan;
                  break;
                case "晚班":
                  v.color = theme.color.teal;
                  break;
                case "中空拉丝棒":
                  v.color = theme.color["r-orange"];
                  break;
                case "高透棒":
                  v.color = theme.color.purple;
                  break;
                case "爆珠棒":
                  v.color = theme.color["m-brand"];
                  break;
              }
              return v.color;
            }
          }
        },
        label: {
          show: true,
          position: "inside",
          backgroundColor: "transparent",
          formatter: v => {
            let vw = (v.value / 10000).toFixed(2);
            return vw + "万";
          }
        },
        data: data[1]
      }
      //   {
      //     name: "出棒率",
      //     type: "line",
      //     symbol: "circle",
      //     symbolSize: 5,
      //     sampling: "average",
      //     xAxisIndex: 1,
      //     color: theme.color.yellow,
      //     label: {
      //       show: true,
      //       position: "top",
      //       backgroundColor: "transparent",
      //       formatter: v => {
      //         return `${(v.value * 100).toFixed(1)} %`;
      //       }
      //     },
      //     data: data[2]
      //   }
    ];

    return option;
  }

  getEvents() {
    let { onClick } = this.props;
    if (!onClick) return {};
    return { click: onClick };
  }

  render() {
    return (
      <ReactEcharts
        option={this.getOption()}
        notMerge={true}
        lazyUpdate={true}
        className={"w-100 h-100"}
        onEvents={this.getEvents()}
      />
    );
  }
}

OutputChart.defaultProps = {
  lineColor: "#f0f0f0",
  ymin: 200,
  ymax: 300,
  x: { data: [] }
};

export class StickTypeChart extends React.Component {
  constructor(props) {
    super(props);
  }

  getItem(name) {
    let data = this.props.data || [];
    return data.find(t => t.name == name) || {};
  }

  getOption() {
    let option = {};
    let my = this;

    let label = {
      lineHeight: 20,
      fontSize: 15,
      formatter: p => {
        let name = p.name;
        let item = this.getItem(name);
        let total = runtime.mobile
          ? `${(item.totalRatio * 100).toFixed(1)}%`
          : `总产量 ${threePosition(item.totalValue)} ${(
            item.totalRatio * 100
          ).toFixed(1)}%`;
        // let qualified = `合格产量 ${threePosition(item.qualifiedValue)} ${(item.qualifiedValueRatio * 100).toFixed(1)}%`;

        return `${name}\n${total}`;
      }
    };

    option.series = [
      {
        type: "treemap",
        width: "98%",
        height: "98%",
        nodeClick: false,
        roam: false,
        breadcrumb: { show: false },
        data: [
          {
            id: 1,
            name: "爆珠棒",
            value: this.getItem("爆珠棒").totalValue,
            label: label
          },
          {
            id: 2,
            name: "高透棒",
            value: this.getItem("高透棒").totalValue,
            label: label
          },
          {
            id: 3,
            name: "中空拉丝棒",
            value: this.getItem("中空拉丝棒").totalValue,
            label: label
          },

          {
            id: 4,
            name: "二元复合棒",
            value: this.getItem("二元复合棒").totalValue,
            label: label
          },
          {
            id: 5,
            name: "三元复合棒",
            value: this.getItem("三元复合棒").totalValue,
            label: { ...label, ...{ fontSize: 10, lineHeight: 15 } }
          },
          {
            id: 6,
            name: "四元复合棒",
            value: this.getItem("四元复合棒").totalValue,
            label: { ...label, ...{ fontSize: 10, lineHeight: 15 } }
          }
        ]
      }
    ];

    return option;
  }

  getEvents() {
    let { onClick } = this.props;
    return {
      click: v => {
        if (onClick) onClick(v.data);
      }
    };
  }

  render() {
    return (
      <ReactEcharts
        option={this.getOption()}
        notMerge={true}
        lazyUpdate={true}
        className={"w-100 h-100"}
        onEvents={this.getEvents()}
      />
    );
  }
}

StickTypeChart.defaultProps = {
  lineColor: "#f0f0f0"
};
